import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { FaCalendarAlt, FaFileExport } from "react-icons/fa";
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';

export default function TabsComponent({ value, setValue }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", mt: 0.5 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#008c23",
          },
        }}
        aria-label="customized tabs example"
        centered
      >
        <Tab
          value="export"
          label="Export"
          iconPosition="start"
          sx={{
            minHeight: 0,
            "&.Mui-selected": {
              color: "#008c23",
            },
          }}
          icon={<FaFileExport />}
        />
        <Tab
          value="schedule"
          label="Schedules"
          iconPosition="start"
          sx={{
            "&.Mui-selected": {
              color: "#008c23",
            },   
          }}
          icon={<FaCalendarAlt />}
        />
        <Tab
          value="history"
          label="Export History"
          iconPosition="start"
          sx={{
            "&.Mui-selected": {
              color: "#008c23",
            },   
          }}
          icon={<HistoryToggleOffIcon />}
        />
      </Tabs>
    </Box>
  );
}
